export type CategoryEntry = {
  [x: string]: any;
  id: number;
  priority:number;
  name: string;

  icon: string | string[];
  pinIcon: string | string[];

  isActive: boolean;

  uploadBy: string;
  approveBy: string;
  status: string;
  statusCode: string;
  publishBy: string;
};

export const defaultCategoryEntry: CategoryEntry = {
  id: 0,
  priority:0,
  name: "",

  icon: [],
  pinIcon: [],

  isActive: true,

  uploadBy: "",
  approveBy: "",
  status: "",
  statusCode: "",
  publishBy: "",
};

export const createDefaultCategoryEntry = (id: number): CategoryEntry => ({
  ...defaultCategoryEntry,
  id,
});

export const removeImageByIndex = (
  imageArray: string[] | string,
  indexToRemove: number
): string[] => {
  const images = Array.isArray(imageArray)
    ? imageArray
    : imageArray
        .split(",")
        .map((img) => img.trim())
        .filter(Boolean);

  return images.filter((_, index) => index !== indexToRemove);
};

const ensureArray = (value: any): string[] => {
  if (typeof value === "string") {
    return value.split(",").map((v) => v.trim());
  } else if (Array.isArray(value)) {
    return value;
  }
  return [];
};

export const prepareCategoryEntryForEdit = (entry: any): CategoryEntry => {
  return {
    ...entry,

    icon: ensureArray(entry.icon),
    pinIcon: ensureArray(entry.pinIcon),
  };
};
